import { render, staticRenderFns } from "./Local.vue?vue&type=template&id=768eab27&scoped=true"
import script from "./Local.vue?vue&type=script&lang=js"
export * from "./Local.vue?vue&type=script&lang=js"
import style0 from "./Local.vue?vue&type=style&index=0&id=768eab27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768eab27",
  null
  
)

export default component.exports